import { a as __rest, b as __assign } from '../tslib.es6-fed6634d.js';
import React from 'react';
import cn from 'classnames';

var styles = {"container":"grid__container_lugg8"};
 require('./container.css')

function Container(_a) {
    var className = _a.className, children = _a.children, component = _a.component, rest = __rest(_a, ["className", "children", "component"]);
    var Component = component !== null && component !== void 0 ? component : 'div';
    return React.createElement(Component, __assign({ className: cn(styles.container, className) }, rest), children);
}

export { Container as default };
